// Horizontal confidence bar. Below the threshold (default 0.80) it fills with
// signal-orange, above it fills with ink. Numeric value sits to the right.

interface Props {
  value: number; // 0..1
  threshold?: number;
}

export function ConfidenceBar({ value, threshold = 0.8 }: Props) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  const lo = value < threshold;
  return (
    <span className="confidence-bar" aria-label={`confidence ${Math.round(pct)}%`}>
      <span
        className={`confidence-bar__fill${lo ? ' confidence-bar__fill--lo' : ''}`}
        style={{ width: `${pct}%` }}
      />
      <span className="confidence-bar__value">{Math.round(pct)}%</span>
    </span>
  );
}
